import { isMobile as isMobileHelper } from 'helpers';

export const shouldRenderCatalogsCarousel = (
  list: Array<unknown>,
  minLengthDesktop: number,
  minLengthMobile: number
) => {
  const isMobile = isMobileHelper();
  if (!list || !list?.length) {
    return false;
  }

  return list?.length > minLengthDesktop || (isMobile && list?.length > minLengthMobile);
};
